<template>
  <div class="bj_show">

    <div class="container-fluid" style="margin-top:0px">
      <div class="row-fluid">
        <!--最新活动-->
        <div class="span12 text-left">
          <div class="container">
            <div class="row">
              <img :src=list.imgages_max width="100%" height="330px" />
            </div>
          </div>

          <div class="tt_10 tt_x_10">
            <h4>{{list.title}}</h4>
            <div class="text-warning"><span class="glyphicon glyphicon-ok-circle"></span> {{list.integral}}</div>
          </div>
          <div class="tt_10 tt_x_10 b_x">
            <div>剩余数量：{{list.surplus}} 件</div>
            <div>提货地址：
              <p v-for="(item,index) in address" :key="index">{{item}}</p>
            </div>
          </div>
          <div class="tt_10 text-center" @click="add_order(list.id)">
            <div class="jumbotron jumbotron_a">
              <h4 style="color:#fff">我要兑换</h4>
              <h5 style="color:#fff">兑换成功后将在我的订单</h5>
            </div>
          </div>
          <div class="tt_10 tt_x_10">
            <h4>详细介绍</h4>
            <div v-html="list.detailed"></div>
          </div>
        </div>

      </div>
      <div id="d_p"></div>
    </div>
  </div>
</template>

<script>
import user_model from '../tool/user_model'
export default {

  data () {
    return {
      selected: '',
      name: '',
      tel: '',
      address: [],
      number: '',
      show: false,
      list: []
    }
  },
  components: {
  },
  props: {
  },
  created () {
  },
  mounted () {
    // http://dns1.hsnms.com:17074/app/data/product/id的值?appid=202108&type_id=9001
    this.$api.getAPI("data/product/" + this.$route.query.id + "?appid=202108&type_id=9001&state=1", {}).then(res => {
      console.log(res.data.data.models);
      this.list = res.data.data.models
      this.address = this.list.key_value.split('｜')
    })
    // console.log(this.$route.query.id);
  },
  methods: {
    // confirm () {
    //   this.$router.push({ name: 'exchange', query: { id: this.list.id, name: this.list.title, price_a: this.list.price_a, imgages_max: this.list.imgages_max, key_value: this.list.key_value } })
    // },
    add_order (id) {
      //alert(id)
      //添加订单
      const info = user_model.getUserinfo();
      let formdata = new FormData()
      formdata.append('openid', info.openid)
      formdata.append('username', info.username)
      formdata.append('telephone', info.telephone)
      //formdata.append('title', this.$route.query.name)
      formdata.append('describe', '积分兑换')
      formdata.append('content_id', id)
      formdata.append('number', 1)
      // formdata.append('time', this.gettime)
      //formdata.append('integral', '-' + name)
      // console.log(this.content_name, this.gettime);
      this.$api.postAPI("mutual/order_integral/?appid=202108&type_id=6001",
        formdata).then(res => {
          //user_order_list
          //
          if (res.data.code == 200) {
            this.$Message.success("兑换成功！");
            this.$router.push('/user_order_list');
          }
          //this.$router.push('/user_order_list')
          //this.$Message.success("评分成功！")
          console.log(res.data);
        })
    }
  }
}
</script>

<style>
.pop {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 99;
}
.edit2 {
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 300px;
  background: #fff;
  z-index: 990;
  overflow: hidden;
  border-radius: 20px;
  padding: 10px 20px;
  box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 15%);
}
.edit2 button {
  height: 35px;
  width: 100px;
  border-radius: 3px;
  border: none;
  background: #1890ff;
  color: #fff;
  margin-left: 10px;
  cursor: pointer;
  margin: 6px auto 10px;
  /* margin-top: 25px; */
  text-align: center !important;
}

.bj_show {
  height: 12rem;
}

/* .container-fluid-a {
  position: absolute;
  top: 50px;
} */

.jumbotron {
  padding: 1rem 1rem;
  margin-bottom: 1rem;
}

.jumbotron_a {
  color: #fff !important;
  background: #01b2c2 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/mall_show.vue